import { render, staticRenderFns } from "./m.vue?vue&type=template&id=5bdae5b1&scoped=true"
import script from "./m.vue?vue&type=script&lang=js"
export * from "./m.vue?vue&type=script&lang=js"
import style0 from "./m.vue?vue&type=style&index=0&id=5bdae5b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdae5b1",
  null
  
)

export default component.exports